export default __webpack_public_path__ + "static/media/mingcute_search-line.efd9f839.svg";